<template>
  <div>
    <div class="col-6 mx-auto shadow p-5">
     <h5 class="text-center text-primary">Sign Up Page</h5>
     <form @submit.prevent="handleSubmit">
        
        <input type="text" class="form-control" placeholder="Full Name" v-model.trim="fullname">
        <input type="text" class="form-control" placeholder="Email" v-model.trim="email">
        <input type="text" v-model.trim="phonenumber" placeholder="Phone Number" class="form-control">
        <input type="password" class="form-control" placeholder="Password" v-model.trim="password">
       <button type="" class="btn btn-outline-primary">Sign Up Here!</button>
     </form>
    </div>
    <p>{{ msg }}</p>
  </div>
  <router-link to="settings">coput!</router-link>
  <router-view></router-view>
</template>

<script>
import axios from 'axios';
export default {
data(){
    return{
        fullname:'',
        email:'',
        password:'',
     phonenumber:'',
     msg:''
    }
},
methods:{
    handleSubmit(){
        let user={
           fullname: this.fullname,
           email:this.email,
           password:this.password,
          phonenumber: this.phonenumber
        }
        axios.post('http://127.0.0.1:8000/api/createstudent',user)
        .then((res)=>{
            console.log(res.data);
            
//             if(res.data.status=='403'){
//                 this.msg=res.data.msg
//             }
//             else if(res.data.status=='201'){
//                 this.$router.push('/login')
//  this.msg=res.data.msg
//             }
            // console.log(res.data);
            
        },
    ).catch((err)=>{
        console.log(err);
        
    })
        console.log(user);
        
    }
}
}
</script>

<style>

</style>